export default "__VITE_ASSET__BL8aZIGD__"